import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Recipes } from 'app/models/receta.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecetaService {
  constructor(private http: HttpClient) {}

  getRecetas(): Observable<Recipes | any> {
    return this.http.get(environment.apiUrl + 'recipes');
  }

  getReceta(id: number) {
    return this.http.get(environment.apiUrl + 'recipes/' + id);
  }

  getInsumosByVariantId(id: number) {
    return this.http.get(environment.apiUrl + 'recipe-article/recipe/' + id);
  }

  updateReceta(id: number, value: any) {
    return this.http.patch(environment.apiUrl + 'recipes/' + id, value);
  }

  saveReceta(value: any) {
    return this.http.post(environment.apiUrl + 'recipes', value);
  }

  deleteReceta(id: number) {
    return this.http.delete(environment.apiUrl + 'recipes/' + id);
  }

  deleteInsumo(id: number) {
    return this.http.delete(environment.apiUrl + 'recipe-article/' + id);
  }
}
